import { forEach } from 'lodash';

import { subscribe } from '../../01-helpers/event-manager';
import { addClass, removeClass } from '../../01-helpers/utilities/class';
import { getCookie } from '../../01-helpers/session-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';

import { CARD_ADDED } from '../../02-const/event-names';
import getFriends from '../../03-api/teetime/getfriends';

import Autocomplete from '../../04-components/autocomplete/autocomplete';
import { ListItem } from '../../04-components/autocomplete/listItem';

const
    moduleName = 'autocomplete',

    selectors = {
        base: `.js-${moduleName}`,
        friendListId: '#friendList',
        storageKey: `MijnGolf_Auth`
    }, translationsKey = {
        key: 'translations',
        BookingNotAllowed: 'BookingNotAllowed'
    },
    cssClasses = {
        showImage: 'is-visible'
    };

export default class FriendsSearch extends Autocomplete {
    constructor(baseElement) {
        super(baseElement);

        this.translations = getPageOptions(translationsKey.key);
}


    /**
     * KeyUp event handler
     * @param {any} evt
     */
    _onKeyUpHandler(evt) {
        const card = this.trigger.closest('.c-card'),
            avatarImg = card.querySelector('.c-card__avatar > img'),
            cardInput = card.querySelector('.c-card__input');

        removeClass(avatarImg, cssClasses.showImage);
        //}

        ///**
        // * Focus event handler 
        // * @param {any} evt
        // */
        //_onFocusHandler(evt) {
        const golfCookie = getCookie(selectors.storageKey);
        // we do this by checking if the authentication cookie is set.
        if (!golfCookie || cardInput.value.length < 3) {
            return false;
        }

        const data = {
            "searchTerm": cardInput.value
            },
            list = this.container.querySelector(selectors.friendListId);

        // call getFriends API
        getFriends(data)
            .done(result => {
                list.innerHTML = '';

                list.insertAdjacentHTML('afterbegin', '<li class="c-filter-list__title unselectable">Vrienden</div>');

                if ((result.Error && result.Error.Code != 0) || result.length <= 0) {
                    list.insertAdjacentHTML('beforeend', '<li class="c-filter-list__info unselectable">Er zijn helaas geen vrienden gevonden.</div>');
                } else {

                    const friends = result.Friends;
                    // add results to the result container
                    forEach(friends, friend => {
                        const message = friend.AllowBooking ? null : this.translations[translationsKey.BookingNotAllowed];
                        const listItem = new ListItem(friend, friend.Fullname, null, message, 'im-people', `{"avatarUrl":"${friend.ImgUrl}"}`);
                        listItem.appendToElement(list);
                    });
                    // add results to the result container
                    this._setClickEvent(list);
                }
                // show the result container if it is not visible yet.
                this.openContainer();
            })
            .fail(error => {
                console.error("Something went wrong with getting friends", error);
            });
    }

    _onItemClickHandler(evt) {
        const element = evt.currentTarget || evt.target,
            value = element.dataset.value;


        // set the value of chosen item in the input as searchTerm
        this.trigger.value = value;
        // set Avatar for chosen item
        const card = this.trigger.closest('.c-card'),
            avatarImg = card.querySelector('.c-card__avatar > img'),
            imgSrc = JSON.parse(element.dataset.attr)?.avatarUrl;

        avatarImg.src = imgSrc || '/';
        this.trigger.dataset.ImgUrl = avatarImg.src;

        if (imgSrc) {
            addClass(avatarImg, cssClasses.showImage);
        } else {
            removeClass(avatarImg, cssClasses.showImage);
        }

        // close the container after a selection is made
        this.closeContainer();

        const changeEvent = new CustomEvent('change', { bubbles: true }),
            inputEvent = new CustomEvent('input', { bubbles: true });

        this.trigger.dispatchEvent(inputEvent);
        this.trigger.dispatchEvent(changeEvent);
    }
}

export { FriendsSearch as FriendsSearch };

subscribe(CARD_ADDED, () => {
    $(selectors.base).each(function () {
        new FriendsSearch(this);
    });
})